import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { authGuard } from '@botto/core';
import HomePage from '@/pages/HomePage.vue';
import NotFoundPage from '@/pages/NotFoundPage.vue';

const baseRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/LoginPage.vue'),
    meta: { title: 'Вход', public: true },
  },
  {
    path: '/',
    name: 'home',
    component: HomePage,
    meta: { title: 'Главная' },
  },
];

/** Added after module routes so the catch-all does not win on first navigation (reload). */
export const notFoundRoute: RouteRecordRaw = {
  path: '/:pathMatch(.*)*',
  name: 'not-found',
  component: NotFoundPage,
  meta: { title: 'Не найдено', public: true },
};

export const router = createRouter({
  history: createWebHistory(),
  routes: baseRoutes,
});

router.beforeEach(authGuard);

router.afterEach((to) => {
  const title = (to.meta?.title as string) || 'Botto Admin';
  document.title = title === 'Botto Admin' ? title : `${title} — Botto Admin`;
});
